import lineClamp from "vue-line-clamp-3";
import { app } from "../app";

app.use(lineClamp);
